import * as Onyx from '../lib/onyx.min.js';

const VERTEX_SHADER = `
    attribute vec3 aVertexScreenPosition;

    void main(void) {
        gl_Position = vec4(aVertexScreenPosition.x, aVertexScreenPosition.y, 1., 1.0);
    }
`

const FRAG_SHADER = `
    #ifdef GL_FRAGMENT_PRECISION_HIGH
        precision highp float;
    #else
        precision mediump float;
    #endif

    #define SKY_COLOR 0.36, 0.65, 0.95
    #define SUN_POSITION 0.3, 0.225, 0.3 // Note: Directional light vector: -0.15, -0.95, 0.15

    uniform mat4 uCMatrix;
    uniform vec2 uResolution;
    uniform float uFOV; 

    // License: BSD
    // by Morgan McGuire, @CasualEffects
    
    float hash(vec2 p) { return fract(1e4 * sin(17.0 * p.x + p.y * 0.1) * (0.1 + abs(sin(p.y * 13.0 + p.x)))); }
    
    float noise(vec2 x) {
        vec2 i = floor(x), f = fract(x);
    
        float a = hash(i);
        float b = hash(i + vec2(1.0, 0.0));
        float c = hash(i + vec2(0.0, 1.0));
        float d = hash(i + vec2(1.0, 1.0));
    
        vec2 u = f * f * (3.0 - 2.0 * f);
        return mix(a, b, u.x) + (c - a) * u.y * (1.0 - u.x) + (d - b) * u.x * u.y;
    }
    
    float fbm(vec2 p) {
        const mat2 m2 = mat2(0.8, -0.6, 0.6, 0.8);
        
        float f = 0.5000 * noise(p); p = m2 * p * 2.02;
        f += 0.2500 * noise(p); p = m2 * p * 2.03;
        f += 0.1250 * noise(p); p = m2 * p * 2.01;
        f += 0.0625 * noise(p);
        return f / 0.9375;
    }
    
    vec3 render(in vec3 light, in vec3 ro, in vec3 rd, in float resolution) {
        vec3 col;
        
        if (rd.y > 0.0) {   
            // Sky with haze		
            col = vec3(SKY_COLOR) * (1.0 - 0.8 * rd.y) * 0.9;
            
            // Sun
            float sundot = clamp(dot(rd, light), 0.0, 1.0);
            col += 0.25 * vec3(1.0, 0.7, 0.4) * pow(sundot, 8.0);
            col += 0.75 * vec3(1.0, 0.8, 0.5) * pow(sundot, 64.0);
    
            // Clouds
            // col = mix(col, vec3(1.0, 0.95, 1.0), 0.5 * 
            //           smoothstep(0.5, 0.8, fbm((ro.xz + rd.xz * (250000.0 - ro.y) / rd.y) * 0.000008)));
        
            // Horizon/atmospheric perspective
            col = mix(col, vec3(0.7, 0.75, 0.8), pow(1.0 - max(abs(rd.y), 0.0), 8.0));
        }
        
        return col;
    }
    
    
    void main(void) {
        vec4 rd = vec4(normalize(vec3(gl_FragCoord.xy - uResolution.xy / 2.0, uResolution.y * 0.5 / -tan(uFOV * 0.5))), 1.0);
        rd *= uCMatrix;

        vec3 light = normalize(vec3(SUN_POSITION));
    
        vec3 col = render(light, vec3(0.0), rd.xyz, uResolution.y);
     
        // Gamma encode
        col = pow(col, vec3(0.5545));
    
        gl_FragColor = vec4( col, 1.0 );
    }
`;

export default class SkyShader extends Onyx.Material {
	constructor() {
        super(...arguments);
        
        this.vertexShader = VERTEX_SHADER;
        this.fragmentShader = FRAG_SHADER;

        this.depthTest = true;
    }
    
    render(dt, scene, viewport, camera, stack, viewMatrix, modelMatrix, frameBufferTextureStack){
        super.render(...arguments);

        viewport.webgl.uniform2fv(viewport.program.uniform.uResolution, [viewport.width, viewport.height]);
        viewport.webgl.uniform1f(viewport.program.uniform.uFOV, camera.fov);

		// Draw
		viewport.webgl.drawArrays(viewport.webgl.TRIANGLES, 0, 6);
    }
}